module.exports = __webpack_public_path__ + "412630c61bae35358abaacad09de457c.jpg";